import {
  paymentMethods as HC_PAYMENT_METHODS,
  PAYMENT_METHOD_FIELDS
} from 'lib/constants/healthcareProgram/paymentSetup';

import Input from 'components/shared/Input/Input';
import Checkbox from 'components/shared/Checkbox/Checkbox';

const CheckNumberInput = ({ values, setFieldValue }) => (
  <Input
    label="Check number"
    placeholder="Enter the check number"
    value={values?.methodDetail ?? ''}
    onChange={(event) => setFieldValue('methodDetail', event.target.value)}
    required
    inputMode="numeric"
    pattern="[0-9]*"
    autoComplete="off"
  />
);

const CreditCardChildren = ({ values, setFieldValue }) => (
  <div className="flex flex-col gap-3 self-start">
    <Checkbox
      size={16}
      isChecked={values.saveCard}
      onChange={(event) => setFieldValue('saveCard', event.target.checked)}
      className="max-w-[456px]"
      innerLabelClassName="items-start"
      labelClassName="text-xs leading-[14px] font-medium"
      label="Save this card for future payments."
    />
  </div>
);

const CreditCardChildrenLocked = () => (
  <div className="flex flex-col gap-3 self-start">
    <Checkbox
      size={16}
      isChecked
      disabled
      className="max-w-[456px]"
      innerLabelClassName="items-start"
      labelClassName="text-xs leading-[14px] font-medium"
      label="Card will be saved on file (required by your practice)."
    />
  </div>
);

export { CreditCardChildrenLocked };

const INTERACTIVE_EXTRAS = {
  [PAYMENT_METHOD_FIELDS.CREDIT_DEBIT_CARD]: { children: CreditCardChildren },
  [PAYMENT_METHOD_FIELDS.CASH]: { kioskOnly: true },
  [PAYMENT_METHOD_FIELDS.CHECK]: { kioskOnly: true, children: CheckNumberInput }
};

export const paymentMethods = HC_PAYMENT_METHODS.map((m) => ({
  id: m.field,
  title: m.title,
  caption: m.description,
  icon: m.icon,
  ...(INTERACTIVE_EXTRAS[m.field] ?? {})
}));

export const applyPhaseTitleOverrides = (methods, { isSelfPay } = {}) =>
  methods.map((m) =>
    m.id === PAYMENT_METHOD_FIELDS.PRE_AUTH
      ? {
          ...m,
          title: isSelfPay
            ? 'Guarantee future balance on my credit card'
            : 'Guarantee any amount not covered by insurance on my credit card'
        }
      : m
  );

export const paymentOptions = [
  {
    id: 'use-my-insurance',
    title: 'Use my insurance',
    icon: 'payers-mono',
    caption: 'Learn More',
    info: `If submitted, your insurance has been reviewed and verified. Please ensure an up-to-date insurance card is provided before treatment.
          If your plan is out-of-network or does not cover certain services, you may be responsible for the full cost or a larger portion of the bill.`
  },
  {
    id: 'self-pay-uninsured',
    title: 'Self-pay / Uninsured',
    icon: 'wallet-mono',
    caption: 'Learn More',
    info: 'I understand I am responsible for the cost of this appointment.'
  }
];
